import { useQuery } from '@tanstack/react-query';
import { vocApi } from '@/lib/api';

/**
 * VoC 週次レポートを取得するフック。
 *
 * 週次でしか更新されないので staleTime は長めに取る。画面を開き直すたびに
 * 取りに行っても内容は変わらない。
 *
 * @graph-stack quality-atelier
 * @graph-domain Quality
 * @graph-business VoC週次レポートを取得するフック。週数ごとにキャッシュする
 * @graph-connects vocApi [calls] VoC APIクライアント呼び出し
 */
export function useVocWeekly(weeks = 12) {
  return useQuery({
    queryKey: ['voc', 'weekly', weeks],
    queryFn: () => vocApi.getWeekly(weeks),
    staleTime: 30 * 60 * 1000,
  });
}
